<script setup>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useCommonComposable } from '@/composables/commonComposable.js';

// Инициализируем стор
const store = useStore();

const { user, getUser, setImageThumbURL } = useCommonComposable();

import { useHead } from '@vueuse/head';
useHead({
    title: "Заказы — Baller | Оригинальные джерси",
    meta: [
        {name: 'description', content: "Описание страницы"}
    ],
})

// Реактивные переменные
const orders = ref([]);

// Вспомогательная функция для получения изображений товара
const getItemImages = (code) => {
    const fetchParams = { productCode: code };
    return store.dispatch('fetchImages', fetchParams)
        .then(() => store.state.images.filter(img => img['Тип'] === 'Заглавная'))
        .catch(err => console.error("Error fetching images:", err));
};

// Основной метод для получения заказов
const getOrderInfo = async () => {
    for (let item of orders.value) {
        await store.dispatch(`order/fetchOrderItems`, {orderId: item["ID"]});
        await store.dispatch(`order/fetchOrderStatuses`, {orderId: item["ID"]});
    }
    orders.value = JSON.parse(JSON.stringify(store.state.order.orders));

    for (let order of orders.value) {
        if (order.orderItems[0]) {
            for (let item of order.orderItems) {
                item.image = setImageThumbURL((await getItemImages(item["Код"]))[0]);
            }
            // order.image = setImageURL((await getItemImages(order.orderItems[0]["Код"]))[0])
        }
    }
};

onMounted(async () => {
    await getUser();
    if (user.value[0]) {
        await store.dispatch(`order/fetchOrders`, { customerId: user.value[0].ID });
    }
    orders.value = JSON.parse(JSON.stringify(store.state.order.orders));

    if (orders.value.length > 0) await getOrderInfo();
});
</script>

<template>
    <div class="col-12 user-orders" v-if="orders.length > 0">
        <div v-for="item of orders" class="order-item">
            <div class="order-info">
                <div class="head">
                    <p class="order-number">Заказ №{{item["Номер"]}}</p>
                    <p class="order-status">{{ item["Статус"] }}</p>
                </div>
                <router-link :to="{name: 'order-item', params: {number: item['Номер']}}" class="btn default">
                    <span>Подробнее</span>
                </router-link>
            </div>
            <div v-if="item.orderItems" class="order-img" :style="`background:url(${item.orderItems[0].image})`">

            </div>
        </div>
    </div>
    <div class="col-12 no-user-orders" v-else>
        <p>Вы еще не совершили ни одного заказа — пока тут пусто. <a href="/products">Продукты</a></p>
    </div>
</template>

<style scoped lang="scss">
@use '~@/assets/styles/vars' as *;
    .no-user-orders {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        padding: 40px 0;
    }

    .no-user-orders a {
        color: $purple;
        text-decoration: underline;
    }

    .user-orders {
        display: flex;
        flex-direction: column;
        gap: 15px
    }
    .order-item {
        background: $white;
        padding: 20px 25px;
        box-sizing: border-box;
        border-radius: 15px;
        display: flex;
        justify-content: space-between;
    }

    .order-item .order-info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex-grow: 1;
    }

    .order-item .head {
        display: flex;
        flex-direction: row;
        gap: 15px
    }

    .order-img {
        background-size: 100% !important;
        background-position: center !important;
        height: 100px;
        aspect-ratio: 1 / 1;
        border-radius: 10px;
        border: 1px solid $gray;
    }

    p {
        font-size: 16px;
    }

    .order-number {
        text-decoration: underline;
    }

    .order-status {
        font-weight: 500;
    }

    @media (max-width: 750px) {
        p {
            font-size: 14px;
        }

        .order-item .head {
            gap: 10px;
            flex-direction: column;
        }

        .order-item {
            padding: 15px 20px;
        }

        .no-user-orders p {
            margin-left: 20px;
        }
    }
</style>